import type { AssessmentListItem } from '@assessments/shared'
import { useRemoteData, type RemoteData } from '../../hooks/useRemoteData.js'
import { fetchAssessments } from './api.js'

export type UseAssessments = Pick<
  RemoteData<AssessmentListItem[]>,
  'data' | 'loading' | 'error' | 'reload'
>

/**
 * Loads the Manage Assessments list. Refetches on window focus so progress made
 * elsewhere (e.g. marking a section complete) is reflected when the respondent
 * returns to the landing page.
 */
export function useAssessments(): UseAssessments {
  return useRemoteData(fetchAssessments)
}
